import React from 'react';
import './styles/NotFoundPage.css'; // Import the stylesheet
import { Link } from 'react-router-dom';
import SEO from "../seo/SEO";
import config from '../config/config';

const NotFoundPage = () => {

    return (
        <>
            <SEO
                robots="noindex, follow"
                title="Page Not Found - Withrow Knives"
                description="Oops! The page you're looking for cannot be found. Return to the homepage and continue browsing Withrow Knives."
                url={`${config.metadata.siteUrl}/404`}
            />


            <div className="not-found-wrapper">
                <div className="not-found-container">
                    <div className="not-found" role="alert" aria-live="assertive">
                        {/* ✅ 404 Heading - Clear & Accessible */}
                        <h1 className="four-o-four">
                            <span className="lean">4</span>&nbsp;04
                        </h1>

                        {/* ✅ Readable Error Message */}
                        <p className="not-found-description">
                            The page you are looking for
                            <br />
                            cannot be found.
                        </p>

                        {/* ✅ Accessible Homepage Link */}
                        <Link to="/" className="not-found-home-button">
                            Return to Homepage
                        </Link>
                    </div>
                </div>
            </div>

        </>
    );
};

export default NotFoundPage;